// Shared marker color logic for 2D and 3D map markers
import type { ScenarioPricing } from "@/types/map";
import { scenarioMarkerColor } from "@/lib/grades";

interface MarkerColorInput {
  outlierPercentage: number;
  dataReady: boolean;
  followed: boolean;
  totalProcedures: number;
  totalChargemasterFiles: number;
  hospitalId: string;
  activeScenarioId: string | null;
  scenarioHospitalPricing: ScenarioPricing;
}

export function getMarkerColor({
  outlierPercentage, dataReady, followed, totalProcedures,
  totalChargemasterFiles, hospitalId, activeScenarioId, scenarioHospitalPricing,
}: MarkerColorInput): string {
  if (activeScenarioId) {
    const scenarioPricing = scenarioHospitalPricing.get(hospitalId);
    if (!scenarioPricing) return '#6b7280';
    return scenarioMarkerColor(scenarioPricing.blendedMarkup);
  }
  if (!followed) return '#9ca3af';
  const isIndexed = totalProcedures > 0 || totalChargemasterFiles > 0 ||
    (outlierPercentage !== undefined && outlierPercentage > 0);
  if (!isIndexed) return '#6b7280';
  if (!dataReady) return '#6b7280';
  if (outlierPercentage >= 40) return '#dc2626';
  if (outlierPercentage >= 25) return '#ea580c';
  if (outlierPercentage >= 10) return '#eab308';
  return '#16a34a';
}
